import React from 'react';
import { I18n } from '@aws-amplify/core';

import { ChipList } from './ChipList';
import { IdentifyButton } from './styles';
import type { SegmentChip } from './utils';

const NO_CHIPS = 0;

interface TlidCellProps {
	fileId: string;
	chips: SegmentChip[];
	disabled?: boolean;
	onIdentify: (fileId: string) => void;
	onRemove: (segmentId: string) => void;
}

export function TlidCell({
	fileId,
	chips,
	disabled = false,
	onIdentify,
	onRemove
}: Readonly<TlidCellProps>): JSX.Element {
	function handleIdentify(): void {
		onIdentify(fileId);
	}

	if (chips.length === NO_CHIPS) {
		return (
			<IdentifyButton disabled={disabled} onClick={handleIdentify}>
				{I18n.get('Identify TLID')}
			</IdentifyButton>
		);
	}

	return <ChipList chips={chips} disabled={disabled} onIdentify={handleIdentify} onRemove={onRemove} />;
}
